import type { PluginObject } from 'vue';
import './styles/index.css';
import * as components from './components';
import * as icons from './icons';
import * as directives from './directives';

const UILib: PluginObject<never> = {
    install(Vue: any) {
        Object.entries(components).forEach(([name, component]) => {
            Vue.component(name, component);
        });

        Object.entries(icons).forEach(([name, icon]) => {
            Vue.component(name, icon);
        });

        Object.entries(directives).forEach(([name, directive]) => {
            Vue.directive(name, directive);
        });
    },
}

export * from './components';
export * from './icons';
export * from './directives';
export default UILib;